import { WARNING_EMOJI } from 'src/common/consts/platformConfigConsts';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

import { LABEL_PREFIXES } from '../pages/tests/types/filter-section-v2/FilterConstants';

const UNIT_ID_PREFIX_LOWER = LABEL_PREFIXES.UNIT_ID.toLowerCase();

const isKnownUnitIdValue = (value: string, unitIdLabelConfig?: ConfigurationLabel): boolean => {
	if (!unitIdLabelConfig?.values) {
		return false;
	}

	const valueLower = value.toLowerCase();
	return unitIdLabelConfig.values.some((configValue) => {
		const configValueStr = typeof configValue === 'string' ? configValue : configValue.value;
		return configValueStr.toLowerCase() === valueLower;
	});
};

export const formatUnitIdDisplayValue = (
	value: string,
	unitIdDisplayName: string,
	unitIdLabelConfig?: ConfigurationLabel
): string => {
	if (!value || !unitIdDisplayName) {
		return value || '';
	}

	const isKnownValue = isKnownUnitIdValue(value, unitIdLabelConfig);
	const hasConfiguredValues = unitIdLabelConfig?.values && unitIdLabelConfig.values.length > 0;

	if (!isKnownValue && hasConfiguredValues) {
		return `${WARNING_EMOJI} ${unitIdDisplayName}: ${value}`;
	}

	return `${unitIdDisplayName}: ${value}`;
};

export const extractUnitIdValue = (label: string): string => {
	if (!label) {
		return '';
	}

	const lowerLabel = label.toLowerCase();

	if (lowerLabel.startsWith(UNIT_ID_PREFIX_LOWER)) {
		return label.substring(UNIT_ID_PREFIX_LOWER.length).trim();
	}

	return label.trim();
};

export const isUnitIdLabelString = (label: string): boolean => {
	if (!label) {
		return false;
	}
	return label.toLowerCase().startsWith(UNIT_ID_PREFIX_LOWER);
};
